import { ORGANIZATION_TYPE_LABELS } from '../../shared/constants/organization-type-options';
import { OrganizationType } from '../data-models/organization-type.model';

/**
 * Returns the display label for an organization type, falling back to the raw
 * value for anything the API sends that isn't in the enum.
 */
export function getOrganizationTypeLabel(type: OrganizationType | string | null | undefined): string {
  if (!type) return '';
  return ORGANIZATION_TYPE_LABELS[type as OrganizationType] ?? type;
}
